import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label", "aria-busy"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "dialog-fields" }
const _hoisted_4 = ["value", "placeholder", "aria-label", "disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]

import { inject, nextTick, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { studioEditorActiveKey } from "./studioSessionHistory";


export default /*@__PURE__*/_defineComponent({
  __name: 'StudioCreateDialog',
  props: {
    modelValue: {},
    title: {},
    label: {},
    placeholder: { default: "" },
    submitLabel: { default: "创建" },
    busy: { type: Boolean, default: false },
    submitDisabled: { type: Boolean }
  },
  emits: ["update:modelValue", "submit", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const dialog = ref<HTMLDialogElement>();
const input = ref<HTMLInputElement>();
const editorActive = inject(studioEditorActiveKey, () => true);
const previousFocus = document.activeElement as HTMLElement | null;

function close() {
  if (!props.busy) emit("close");
}
function submit() {
  if (!props.busy && !props.submitDisabled && props.modelValue.trim()) emit("submit");
}
function backdropClick(event: MouseEvent) {
  if (event.target !== dialog.value || !dialog.value) return;
  const bounds = dialog.value.getBoundingClientRect();
  if (event.clientX < bounds.left || event.clientX > bounds.right ||
      event.clientY < bounds.top || event.clientY > bounds.bottom) close();
}
onMounted(() => {
  if (!editorActive()) return;
  dialog.value?.showModal();
  input.value?.focus();
});
watch(editorActive, active => {
  if (!active) { dialog.value?.close(); emit("close"); }
}, { flush: "sync" });
onBeforeUnmount(() => {
  dialog.value?.close();
  void nextTick(() => {
    if (previousFocus?.isConnected && !previousFocus.closest("[inert]") && previousFocus.getClientRects().length) previousFocus.focus();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dialog", {
    ref_key: "dialog",
    ref: dialog,
    class: "studio-create-dialog dsfg-typography",
    "aria-label": __props.title,
    "aria-busy": __props.busy,
    onCancel: _withModifiers(close, ["prevent"]),
    onClick: backdropClick
  }, [
    _createElementVNode("form", {
      onSubmit: _withModifiers(submit, ["prevent"])
    }, [
      _createElementVNode("header", null, [
        _createElementVNode("h2", null, _toDisplayString(__props.title), 1),
        _createElementVNode("button", {
          type: "button",
          class: "dialog-close",
          disabled: __props.busy,
          "aria-label": "关闭",
          onClick: close
        }, "×", 8, _hoisted_2)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", null, [
          _createTextVNode(_toDisplayString(__props.label), 1),
          _createElementVNode("input", {
            ref_key: "input",
            ref: input,
            value: __props.modelValue,
            placeholder: __props.placeholder,
            "aria-label": __props.label,
            disabled: __props.busy,
            required: "",
            autofocus: "",
            autocomplete: "off",
            onInput: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', ($event.target as HTMLInputElement).value)))
          }, null, 40, _hoisted_4)
        ]),
        _renderSlot(_ctx.$slots, "default", { overlayTarget: dialog.value })
      ]),
      _createElementVNode("footer", null, [
        _createElementVNode("button", {
          type: "button",
          disabled: __props.busy,
          onClick: close
        }, "取消", 8, _hoisted_5),
        _createElementVNode("button", {
          type: "submit",
          class: "dialog-primary",
          disabled: __props.busy || __props.submitDisabled || !__props.modelValue.trim()
        }, _toDisplayString(__props.busy ? '创建中…' : __props.submitLabel), 9, _hoisted_6)
      ])
    ], 32)
  ], 40, _hoisted_1))
}
}

})